module.exports = __webpack_public_path__ + "images/ebb60bb5769dfc1dd1e3642c7752c8be.svg";